import { App } from './App';
new App().start().catch(err => {
  setTimeout(() => {
    throw err;
  }, 0);
});